import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";
import { useGet } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useQueryClient } from "@tanstack/react-query";
import { Img } from "./kit";

export function SecretPopup() {
  const { me } = useAuth();
  const qc = useQueryClient();
  const q = useGet("/temp-photos", { interval: 30000 });
  const next = (q.data?.incoming || [])[0];
  const [view, setView] = useState(null);
  useEffect(() => {
    if (next && !view) { api.post(`/temp-photos/${next.id}/reveal`).then((r) => setView(r.data)).catch(() => qc.invalidateQueries({ queryKey: ["/temp-photos"] })); }
  }, [next?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!view) return null;
  const close = async () => {
    const id = view.id;
    setView(null);
    await api.post(`/temp-photos/${id}/close`).catch(() => {});
    qc.invalidateQueries({ queryKey: ["/temp-photos"] });
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-md flex items-center justify-center p-5 pt-safe pb-safe" onClick={close} data-testid="secret-photo-popup">
      <div className="relative card p-3 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <button className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-white text-black flex items-center justify-center shadow-lg" onClick={close} data-testid="secret-photo-close" aria-label="Close"><X size={20} /></button>
        <p className="label-xs mb-2 px-1">Secret picture from {me.partner_name}</p>
        <Img id={view.media_id} loading="eager" className="w-full max-h-[70vh] rounded-2xl !object-contain bg-black" data-testid="secret-photo-image" />
        <p className="text-[11px] text-oh-text2 mt-2 px-1">Shown once — it disappears when you close it.</p>
      </div>
    </div>
  );
}
